<svg:svg
    preserveAspectRatio="xMaxYMax meet"
    style="margin: auto; background: transparent; display: block; shape-rendering: auto;"
    [attr.width]="pxSvgWidth"
    [attr.height]="pxSvgHeight"
    [class.disabled]="disabled"
>
    <svg:svg
        [attr.x]="offsetX"
        [attr.y]="offsetY"
        [attr.width]="pxSliderWidth"
        [attr.height]="pxSliderHeight"
    >
        <svg:g [attr.transform]="translate1">
            <rect
                height="7px"
                rx="3"
                stroke-width="0.25px"
                x="0"
                y="0"
                [attr.width]="pxSliderWidth"
                class="axis"
            ></rect>
        </svg:g>
        <svg:g [attr.transform]="translate2">
            <svg:rect
                *ngFor="let x of xCoords; index as idx"
                [attr.x]="x - 2"
                y="0"
                rx="2"
                width="4px"
                [attr.height]="pxTickHeight"
                stroke-width="0.25px"
                class="tick"
                (click)="onClickTick(idx)"
            ></svg:rect>
            <svg:text
                class="tick"
                *ngFor="let step of steps; index as idx"
                attr.transform="translate({{ xCoords[idx] }}, 50)"
                (click)="onClickTick(idx)"
                [ngClass]="{ selected: selectedStep === idx }"
            >
                {{ step }}
            </svg:text>
            <svg:path
                id="cursor"
                class="cursor"
                [attr.transform]="posSlider"
                d="M -4 0 h 8 v 20 l -4 16 l -4 -16 z"
                stroke-linejoin="round"
            ></svg:path>
        </svg:g>
    </svg:svg>
</svg:svg>
